import { useMemo } from "react";
import styles from "./UserChatMessage.module.css";

interface Props {
    message: string;
    dateCode?: string;
}

export const UserChatMessage = ({ message, dateCode }: Props) => {
    const formattedDate = useMemo(() => {
        return dateCode
            ? new Date(dateCode.replace(/(\.\d{3})\d+/, "$1")).toLocaleString("bg-BG", {
                  month: "numeric",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit"
              })
            : null;
    }, [dateCode]);

    return (
        <div className={styles.container}>
            <div className={styles.message}>{message}</div>
            {formattedDate && <div className={styles.dateCodeContainer}>{formattedDate}</div>}
        </div>
    );
};
